// extracted by mini-css-extract-plugin
export default {"form":"styles_form__ZIs7s","input":"styles_input__+Zr-c","photoContainer":"styles_photoContainer__C-U6c","image":"styles_image__AyGdX"};